import axios from 'axios';
import store from '../index';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
const state = {
	items: [],
	item: [],
	index: '',
	sortBy: '',
	sortDesc: '',
};

const getters = {
	getItems: state => {
		return state.items;
	},
	getItem: state => {
		return state.item;
	},
	getIndex: state => {
		return state.index;
	},
	getSortBy: state => {
		return state.sortBy;
	},
	getSortDesc: state => {
		return state.sortDesc;
	},
};

const actions = {
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'ddts';

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters['ddts/getSortBy'],
						sortDesc: context.rootGetters['ddts/getSortDesc'],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);
			await context.commit('setItems', res.data.data);
			return res.data.pagination;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	asyncSearchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'items';

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);
		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters['ddts/getSortBy'],
						sortDesc: context.rootGetters['ddts/getSortDesc'],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return res.data.data;

				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
			});
	},

	deleteItems: async (context, data) => {
		let url = 'ddts/delete';
		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, data, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => {
				//console.log(res.data.pagination);
				//context.commit('setCategories', res.data.data);
				return res.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err.response.status);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }*/
				return { error: err.response.status };
				//throw Error(err.response.status);
			});
	},
	deleteInventory: async (context, data) => {
		let url = 'ddts/deleteinventory';
		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, data, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => {
				//console.log(res.data.pagination);
				//context.commit('setCategories', res.data.data);
				return res.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err.response.status);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }*/
				return { error: err.response.status };
				//throw Error(err.response.status);
			});
	},
	confirmInventory: async (context, data) => {
		let url = 'ddts/confirmInventory';
		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, data, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => {
				//console.log(res.data.pagination);
				//context.commit('setCategories', res.data.data);
				return res.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err.response.status);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }*/
				return { error: err.response.status };
				//throw Error(err.response.status);
			});
	},
	createInventory: async (context, data) => {
		try {
			let url = 'ddts/createinventory';
			const res = await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, data, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			});
			return res.data;
		} catch (err) {
			console.log('errore', err.response.status);

			return { error: err.response.status };
		}
	},
	updateItems: async (context, data) => {
		let url = 'ddts/update';
		return await axios
			.put(
				`${context.rootGetters['settings/getUrl']}${url}`,

				data,
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				//console.log(res.data.pagination);
				//context.commit('setCategories', res.data.data);
				return res.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err.response.status);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }*/
				return { error: err.response.status };
				//throw Error(err.response.status);
			});
	},
	destroyData: context => {
		context.commit('setItems', []);
		context.commit('setItem', []);
		context.commit('setIndex', '');
	},
};

const mutations = {
	setItems: async (state, value) => {
		state.items = value;
	},
	setItem: (state, value) => {
		state.item = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
